import React, { Component } from 'react';
import PubButtons from './PubButtons'

class Quote extends Component {
  render() {
  
    let citation = {};
    if (this.props.info) {
      citation = this.props.info;
    } else {
      citation = (
        ({ title, authors, publisher, year, url, pubmed, pmc, researchgate, pdf, type }) => (
          { title, authors, publisher, year, url, pubmed, pmc, researchgate, pdf, type }
        )
      )(this.props);
      citation["text"] = this.props.children;
    }
    
    let left_border = "3px solid darkred";
    if (citation.pmc) {left_border = "3px solid gold"}
    else if (citation.pubmed) {left_border = "3px solid violet"}
    
    let { authors, publisher, year, text, title, ...button_values } = citation;
    // Replace line ending that is not a period or question mark with a period
    title = title.trim().replace(/$(?<=[^.?])/,".");
    if (authors) {
      authors = authors.trim().replace(/$(?<=[^.])/,".");
    }
    // Alternative if using a browser that doesn't support regex lookbehind
    // title = title.trim();
    // if ((title[title.length-1] !== ".") && (title[title.length-1] !== "?")) {
    //   title += ".";
    // }
    // if (authors) {
    //   authors = authors.trim();
    //   if (authors[authors.length-1] !== ".") {
    //     authors += ".";
    //   }
    // }

    return(
      <div className="quote" key={title} style={{borderLeft:left_border}}>
        <div>
          <div className="title">
            <PubButtons {...button_values} title={title} />
            <div style={{fontSize:"smaller"}}>{authors} "{title}" <i>{publisher}</i>{publisher&&","} {year}.</div>
          </div>
          {(text&&
          <div className="quote-text">
            <div className="quote-text-open">&ldquo;</div>
            <div className="quote-text-inner" dangerouslySetInnerHTML={{__html:text}}/>
            <div className="quote-text-close">&rdquo;</div>
          </div>
          )}
        </div>
      </div>
    );
  }
}

export default Quote;